"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
const Feesable_1 = __importDefault(require("./Feesable"));
const util_1 = require("./services/util");
const constants_1 = require("./shared/constants");
const react_microsoft_clarity_1 = require("react-microsoft-clarity");
const init = () => {
    // Added this to prevent webpack errors
    if (window.location.pathname.includes('/fee-table')) {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    }
    const el = document.getElementById('feesable');
    if (!el) {
        throw new Error('Feesable container is not present');
    }
    const attrs = el.attributes;
    const props = (0, util_1.attrToObj)(attrs);
    // Add a class to the body.
    // Use this class to scope the css selectors.
    document.body.classList.add(constants_1.BODY_CLASS_NAME);
    // MS Clarity
    if (process.env.NODE_ENV === 'production') {
        const clarityId = process.env.REACT_APP_MS_CLARITY_ID;
        if (clarityId) {
            react_microsoft_clarity_1.clarity.init(clarityId);
        }
    }
    react_dom_1.default.render((0, jsx_runtime_1.jsx)(react_1.default.StrictMode, { children: (0, jsx_runtime_1.jsx)(Feesable_1.default, Object.assign({}, props)) }), el);
};
init();
